import React, { useMemo } from 'react';
import { ToastrManager } from '@so/components';
import ToastNotifierStyles from './ToastNotifierStyles';
import { TOAST_MESSAGE_ERROR_AUTOCLOSE_DELAY } from '../../utils/const';

const ToastNotifier = () => {
  const autoClose = useMemo(() => {
    if (process.env?.REACT_APP_TOAST_MSG_DISABLE_AUTO_CLOSE) {
      return false;
    }
    return TOAST_MESSAGE_ERROR_AUTOCLOSE_DELAY;
  }, []);

  return (
    <>
      <ToastrManager autoClose={autoClose} />
      {<ToastNotifierStyles />}
    </>
  );
};

export default ToastNotifier;
